import styled, {css} from "styled-components";
import {GhostButton, PrimaryButton} from "account/components/AccountCards";
import {SuccessNote} from "account/withdrawal/WithdrawalSubmissionDialog.styles";

// The booking entry and receipt action sit outside DialogActions, which otherwise supplies this target size.
const touchTarget = css`
	min-height: 44px;
	height: auto;
	max-width: 100%;
	white-space: normal;
	overflow-wrap: anywhere;
`;

export const WithdrawalTrigger = styled(GhostButton)`${touchTarget}`;
export const ReceiptDone = styled(PrimaryButton)`${touchTarget}`;

/** A valid name can be one long word; preserve the recorded line breaks without horizontal scrolling. */
export const RecordedDeclaration = styled(SuccessNote)`
	min-width: 0;
	max-width: 100%;
	overflow-wrap: anywhere;
	white-space: pre-wrap;
`;
